// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1DGrI","consentsList":"PatientConsents_consentsList__32S4E","consentsListEmpty":"PatientConsents_consentsListEmpty__3-nAk"};